<template>  
    <div class="header">
        <slot></slot>
    </div>
</template>

<script>
import {  defineComponent } from 'vue';

export default defineComponent({ 
    setup: function () { 
    }
})
</script>

<style lang="scss" scoped> 
.header{
    @apply text-16 pl-6 pr-6 py-3 pb-4 text-a-black-555555 mb-5;
}
</style>